import FontBody1 from "../../../fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../fonts/font-props";
import { BUTTON_VARIANTS } from "../../../inputs/button-variants";
import { Button } from "../../../inputs/button/button";
import {DatePickerVariant} from "../../date-range-picker-v2";

interface IDateRangePickerWrapperProps {
    disabled?: boolean,
    datePreview?: React.ReactNode,
    variant?: DatePickerVariant,
    onClear: () => void,
    onApply: () => void,
    children?: React.ReactNode|null,
}

/** This component used purely for styling 3rd party DatePicker */
const DateRangePickerWrapper: React.FC<IDateRangePickerWrapperProps> = ({ disabled, datePreview, variant = DatePickerVariant.DATE_RANGE, children, onClear: onCancel, onApply }) => {
    return (
        <div className={`${variant}-calendar-container ${disabled ? 'disabled' : ''}`}>
            <div className="calendar">
                {children}
            </div>
            <div className="footer">
                {datePreview && <div className="preview">
                    <FontBody1 color={FONT_COLOR.PRIMARY3}>
                        {datePreview}
                    </FontBody1>
                </div>}
                <div className="buttons">
                    <Button
                        text='Clear'
                        onClick={onCancel}
                        variant={BUTTON_VARIANTS.Tertiary}
                    />
                    <Button
                        text='Apply'
                        onClick={onApply}
                        variant={BUTTON_VARIANTS.PrimaryAccent}
                    />
                </div>
            </div>
        </div>
    )
};

export default DateRangePickerWrapper;